import React, { Component, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import '../App.css';
import Sidebar from './Sidebar';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import { RootState } from '../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import WithTracker from './withTracker';
import PageBlocker from '../util/PageBlocker';
import EnvironmentUtil from '../util/EnvironmentUtil';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import Header from '../components/custom/header/Header';
import { AuthState } from '../redux/reducers/AuthReducer';
import moment from 'moment';
import MessageUtil from '../util/MessageUtil';
import UserService from '../service/UserService';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import LanguageUtil from '../util/LanguageUtil';
import BulkActionConfirmDialog from '../components/custom/BulkActionConfirmDialog';
import UndeployImpactDialog from '../components/deploy/UndeployImpactDialog';

class AppContainer extends Component<Props> {
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  private readonly userService: UserService = ServiceContainer.getInstance().get(ServiceNames.USER);

  public render(): ReactNode {
    const { collapsed, component } = this.props;

    return (
      <WithTracker mouse={this.environmentUtil.isMouseTrack()} pageChange={this.environmentUtil.isPageChange()}>
        <PageBlocker />
        <div className='flex w-full flex-col lg:overflow-hidden lg:max-h-screen lg:h-screen h-full font-custom ' id={'outlet'}>
          <Header component={component} />
          <div className={'flex w-full h-full'}>
            <div
              className={`hidden ${collapsed ? 'w-[88px]' : 'w-[180px] 2xl:w-[241px]'} ease-in-out duration-500 h-screen flex-col lg:flex lg:flex-shrink-0 lg:!max-h-[calc(100vh-60px)]`}
            >
              <Sidebar />
            </div>
            <div className='grid h-full grid-cols-1 w-full overflow-y-hidden'>
              <div className='border-l flex h-screen flex-col col-span-1 lg:!max-h-[calc(100vh-60px)]'>
                <Outlet />
                <BulkActionConfirmDialog />
                <UndeployImpactDialog />
              </div>
            </div>
          </div>
        </div>
      </WithTracker>
    );
  }

  public componentDidMount() {
    const { user } = this.props;
    const fontSize = user.user!.preferences.fontSize;
    if (fontSize) {
      const htmlElement = document.getElementsByTagName('html')[0];
      htmlElement.style.fontSize = fontSize;
    }
    if (user.attributes.login && !user.attributes.login.read && user.attributes.login.loginAttempts.some((a) => !a.success)) {
      const failedLoginAttempts = user.attributes.login.loginAttempts
        .filter((a) => !a.success)
        .map((a) => ({
          timestamp: moment(a.timestamp).format('LLL'),
          ip: a.ip,
        }));
      MessageUtil.warning({
        life: 1_000_000,
        detail: (
          <div className='flex w-full gap-y-4 flex-col'>
            {failedLoginAttempts.map((a) => (
              <p key={a.timestamp}>{LanguageUtil.get({ id: 'messages.warning.date' }, { 0: `${a.timestamp}`, 1: `${a.ip}` })}</p>
            ))}
          </div>
        ),
        summary: LanguageUtil.get({ id: 'messages.failed.loginFailed', defaultMessage: 'Failed Login Attempts' }),
      });
      this.userService.readErrorLoginNotification();
    }
  }
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  collapsed: state.page.sidebarCollapsed,
  user: state.auth as AuthState,
  component: state.component,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default withFormica(connector(AppContainer));
